import { render, staticRenderFns } from "./chat-messages.vue?vue&type=template&id=493b2a0b&"
import script from "./chat-messages.vue?vue&type=script&lang=js&"
export * from "./chat-messages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports